(function () {
  "use strict";

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function money(cents, currency) {
    if (typeof cents !== "number") cents = parseFloat(cents) || 0;
    try {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: currency || "USD" }).format(cents / 100);
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Drawers ---------- */
  var drawers = qsa("[data-drawer]");
  var overlay = qs("[data-overlay]");

  function openDrawer(id) {
    var d = qs('[data-drawer="' + id + '"]');
    if (!d) return;
    d.classList.add("open");
    d.setAttribute("aria-hidden", "false");
    if (overlay) overlay.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawers() {
    qsa("[data-drawer].open").forEach(function (d) {
      d.classList.remove("open");
      d.setAttribute("aria-hidden", "true");
    });
    if (overlay) overlay.classList.remove("open");
    document.body.style.overflow = "";
  }

  qsa("[data-open-drawer]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      openDrawer(btn.getAttribute("data-open-drawer"));
    });
  });
  qsa("[data-close-drawer]").forEach(function (btn) {
    btn.addEventListener("click", closeDrawers);
  });
  if (overlay) overlay.addEventListener("click", closeDrawers);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawers();
  });

  /* ---------- Desktop nav dropdown ---------- */
  qsa(".nav-item--dropdown").forEach(function (li) {
    var link = qs("a.has-dropdown", li);
    var dd = qs(".nav-dropdown", li);
    if (!link || !dd) return;
    link.addEventListener("click", function (e) {
      e.preventDefault();
      var open = dd.classList.contains("open");
      qsa(".nav-dropdown.open").forEach(function (o) { o.classList.remove("open"); });
      if (!open) dd.classList.add("open");
    });
    li.addEventListener("mouseenter", function () { dd.classList.add("open"); });
    li.addEventListener("mouseleave", function () { dd.classList.remove("open"); });
  });
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".nav-item--dropdown")) {
      qsa(".nav-dropdown.open").forEach(function (o) { o.classList.remove("open"); });
    }
  });

  /* ---------- Sticky header / back to top ---------- */
  var backToTop = qs(".back-to-top");
  function onScroll() {
    var y = window.scrollY || document.documentElement.scrollTop;
    if (backToTop) backToTop.classList.toggle("show", y > 600);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
  if (backToTop) {
    backToTop.addEventListener("click", function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  /* ---------- Carousels ---------- */
  qsa("[data-carousel]").forEach(function (carousel) {
    var viewport = qs(".carousel__viewport", carousel);
    if (!viewport) return;
    var step = function (dir) {
      var slide = viewport.querySelector(".carousel__slide");
      if (!slide) return;
      var amount = slide.getBoundingClientRect().width + 22;
      viewport.scrollBy({ left: dir * amount, behavior: "smooth" });
    };
    var prev = qs(".carousel__nav--prev", carousel);
    var next = qs(".carousel__nav--next", carousel);
    if (prev) prev.addEventListener("click", function () { step(-1); });
    if (next) next.addEventListener("click", function () { step(1); });
    viewport.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { step(-1); e.preventDefault(); }
      if (e.key === "ArrowRight") { step(1); e.preventDefault(); }
    });
  });

  /* ---------- Countdown timer ---------- */
  qsa("[data-countdown]").forEach(function (el) {
    var target = new Date(el.getAttribute("data-countdown")).getTime();
    if (isNaN(target)) return;
    var boxes = { d: qs('[data-unit="days"]', el), h: qs('[data-unit="hours"]', el), m: qs('[data-unit="minutes"]', el), s: qs('[data-unit="seconds"]', el) };
    function pad(n) { return String(n).padStart(2, "0"); }
    function tick() {
      var diff = Math.max(0, target - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (boxes.d) boxes.d.textContent = pad(d);
      if (boxes.h) boxes.h.textContent = pad(h);
      if (boxes.m) boxes.m.textContent = pad(m);
      if (boxes.s) boxes.s.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Product gallery thumbs ---------- */
  qsa("[data-gallery]").forEach(function (gallery) {
    var main = qs("[data-gallery-main]", gallery);
    var thumbs = qsa("[data-thumb]", gallery);
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        if (!main) return;
        main.src = t.getAttribute("data-full");
        main.alt = t.getAttribute("data-alt") || main.alt;
        thumbs.forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
      });
    });
  });

  /* ---------- AJAX cart ---------- */
  var cartDrawer = qs('[data-drawer="cart"]');
  var cartBody = qs("[data-cart-body]", cartDrawer);
  var cartCountEls = qsa("[data-cart-count]");

  function setCartCount(n) {
    cartCountEls.forEach(function (el) { el.textContent = n; el.style.display = n > 0 ? "" : "none"; });
  }
  function renderCart(cart) {
    if (!cartBody) return;
    setCartCount(cart.item_count);

    if (!cart.item_count) {
      var emptyMsg = cartBody.getAttribute("data-empty-html") || "<p>Your cart is empty.</p>";
      cartBody.innerHTML = '<div class="cart-empty">' + emptyMsg + "</div>";
      return;
    }

    var itemsHtml = cart.items.map(function (item) {
      var img = item.image
        ? '<img class="cart-item__img" src="' + item.image + '" alt="' + (item.title || "").replace(/"/g, "&quot;") + '">'
        : '<div class="cart-item__img"></div>';
      return (
        '<li class="cart-item" data-key="' + item.key + '">' +
        img +
        '<div>' +
        '<div class="cart-item__title">' + (item.product_title || item.title || "") + "</div>" +
        '<div class="cart-item__meta">' + (item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "") + "</div>" +
        '<div class="cart-item__qty">' +
        '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button>' +
        '<input type="text" value="' + item.quantity + '" data-qty-input aria-label="Quantity" inputmode="numeric">' +
        '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
        "</div>" +
        '<button type="button" class="cart-item__remove" data-remove-item>Remove</button>' +
        "</div>" +
        '<div class="cart-item__price">' + money(item.final_line_price, cart.currency) + "</div>" +
        "</li>"
      );
    }).join("");

    var note = cartBody.getAttribute("data-note") || "";
    var threshold = parseFloat(cartBody.getAttribute("data-threshold") || "0");
    var remaining = Math.max(0, threshold - cart.total_price / 100);
    var pct = threshold ? Math.min(100, (cart.total_price / 100 / threshold) * 100) : 100;
    var freeMsg = remaining > 0
      ? "You are " + money(remaining * 100, cart.currency) + " away from free shipping"
      : "You have unlocked free shipping 🎉";

    cartBody.innerHTML =
      '<ul class="cart-items">' + itemsHtml + "</ul>" +
      '<div class="cart-footer">' +
      (threshold ? '<div class="free-ship-bar" role="progressbar" aria-label="Free shipping progress"><span style="width:' + pct + '%"></span></div><div class="cart-note">' + freeMsg + "</div>" : "") +
      (note ? '<div class="cart-note">' + note + "</div>" : "") +
      '<div class="cart-subtotal"><span>Subtotal</span><span data-cart-total>' + money(cart.total_price, cart.currency) + "</span></div>" +
      '<form action="/cart" method="post" class="mb-2"><button type="submit" name="checkout" class="btn btn--primary btn--full">Checkout</button></form>' +
      '<a href="/cart" class="btn btn--outline btn--full">View cart</a>' +
      "</div>";

    qsa("[data-remove-item]", cartBody).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.closest(".cart-item").getAttribute("data-key");
        changeItem(key, 0);
      });
    });
    qsa("[data-qty-change]", cartBody).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var li = btn.closest(".cart-item");
        var key = li.getAttribute("data-key");
        var input = qs("[data-qty-input]", li);
        var qty = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute("data-qty-change"), 10));
        changeItem(key, qty);
      });
    });
    qsa("[data-qty-input]", cartBody).forEach(function (input) {
      input.addEventListener("change", function () {
        var li = input.closest(".cart-item");
        var key = li.getAttribute("data-key");
        var qty = Math.max(1, parseInt(input.value, 10) || 1);
        changeItem(key, qty);
      });
    });
  }

  function refreshCart() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeItem(key, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function addToCart(id, quantity) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: id, quantity: quantity || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCart();
        openDrawer("cart");
      })
      .catch(function () {});
  }

  /* Add-to-cart buttons (quick-add on product cards) */
  qsa("[data-add-to-cart][data-quick-add]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (btn.disabled) return;
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = "Adding…";
      addToCart(btn.getAttribute("data-add-to-cart"), parseInt(btn.getAttribute("data-qty") || "1", 10));
      setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1200);
    });
  });

  /* Product page: variant + qty wiring */
  var variantSelect = qs("[data-variant-select]");
  var qtyInput = qs("[data-product-qty]");
  var addBtn = qs("[data-add-to-cart]");
  var priceEl = qs("[data-product-price]");
  var compareEl = qs("[data-compare-price]");
  var variants = [];
  var variantMeta = qs("[data-variants-json]");
  if (variantMeta) {
    try { variants = JSON.parse(variantMeta.textContent); } catch (e) { variants = []; }
  }
  function updateVariant() {
    if (!variantSelect || !addBtn || variants.length === 0) return;
    var v = variants.filter(function (x) { return String(x.id) === String(variantSelect.value); })[0];
    if (!v) return;
    if (v.available) {
      addBtn.disabled = false;
      addBtn.setAttribute("data-add-to-cart", v.id);
      addBtn.textContent = addBtn.getAttribute("data-label-default") || "Add to Cart";
    } else {
      addBtn.disabled = true;
      addBtn.textContent = addBtn.getAttribute("data-label-soldout") || "Sold out";
    }
    if (priceEl) priceEl.textContent = money(v.price, "USD");
    if (compareEl && v.compare_at_price > v.price) {
      compareEl.style.display = "";
      compareEl.textContent = money(v.compare_at_price, "USD");
    } else if (compareEl) {
      compareEl.style.display = "none";
    }
  }
  if (variantSelect) {
    variantSelect.addEventListener("change", updateVariant);
    updateVariant();
  }
  if (addBtn && qtyInput) {
    addBtn.addEventListener("click", function () {
      if (addBtn.disabled) return;
      addToCart(addBtn.getAttribute("data-add-to-cart"), parseInt(qtyInput.value || "1", 10));
    });
  }
  qsa("[data-qty-step]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var input = qs("[data-product-qty]");
      if (!input) return;
      var qty = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute("data-qty-step"), 10));
      input.value = qty;
    });
  });

  /* Refresh cart on load so the badge is correct */
  refreshCart();

  /* Cart page: qty steppers + remove submit the form after updating inputs */
  qsa("[data-qty-page-change]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.getAttribute("data-qty-page-change");
      var input = qs('[data-qty-page="' + key + '"]');
      var form = btn.closest("form");
      if (!input || !form) return;
      var qty = Math.max(0, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute("data-step"), 10));
      input.value = qty;
      form.submit();
    });
  });
  qsa("[data-remove-page-item]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.getAttribute("data-remove-page-item");
      var input = qs('[data-qty-page="' + key + '"]');
      var form = btn.closest("form");
      if (!input || !form) return;
      input.value = 0;
      form.submit();
    });
  });

  /* Mobile footer menu toggle */
  qsa("[data-footer-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var footer = btn.closest(".site-footer");
      if (!footer) return;
      var open = footer.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  /* Highlight active nav link */
  var currentPath = (window.location.pathname || "/").replace(/\/+$/, "") || "/";
  qsa("[data-nav-link]").forEach(function (a) {
    var href = (a.getAttribute("href") || "").replace(/\/+$/, "") || "/";
    if (href === currentPath || (href !== "/" && currentPath.indexOf(href) === 0)) {
      a.setAttribute("aria-current", "page");
    }
  });
})();
